module.exports = __webpack_public_path__ + "img/7-1.99585b5f.png";